export default "__VITE_ASSET__CkOjfKX8__"